import request, { METHODS } from "src/utils/api-base";

const tenantDepartmentApis = {
  createTenantDepartment: (payload: any) => {
    return request({
      route: "/app/tenant-departments",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getTenantDepartmentList: (params: {
    page?: number;
    limit: number;
    search?: string;
  }) => {
    return request({
      route: "/app/tenant-departments",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  editTenantDepartment: (payload: any) => {
    return request({
      route: `/app/tenant-departments/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  deleteTenantDepartment: (_id: string) => {
    return request({
      route: `/app/tenant-departments/${_id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },
};

export default tenantDepartmentApis;
